import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import './styles/footer.css';


class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
    <div className = "container-fluid footer-container">
        <div className = "footer">
            <span>Powered by<br/>FABSTECH LIMITED</span>
        </div>
    </div>
    );
  }
}

export default Footer;